import React, { useState } from "react";
import { Row, Col, Card, Tabs, Table, Select } from "antd";
import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    Tooltip,
    ResponsiveContainer,
} from "recharts";

export default function CustomerDashboardDemo() {
    const [year, setYear] = useState("2025");
    const [hiddenLines, setHiddenLines] = useState<string[]>([]);
    const [tab, setTab] = useState("service");

    // ===== DATA CHART =====
    const chartData = [
        { name: "Th 1", service: 12, product: 4 },
        { name: "Th 2", service: 17, product: 7 },
        { name: "Th 3", service: 14, product: 5 },
        { name: "Th 4", service: 18, product: 11 },
        { name: "Th 5", service: 15, product: 12 },
        { name: "Th 6", service: 13, product: 14 },
        { name: "Th 7", service: 7, product: 10 },
        { name: "Th 8", service: 14, product: 7 },
        { name: "Th 9", service: 19, product: 8 },
        { name: "Th 10", service: 5, product: 15 },
        { name: "Th 11", service: 14, product: 10 },
        { name: "Th 12", service: 3, product: 5 },
    ];

    // ===== TABLE DATA =====
    const serviceData = [
        {
            key: 1,
            code: "#85357663",
            branch: "Chi nhánh 100",
            customer: "Huan Cao",
            createdBy: "Admin User",
            time: "16:11:29 17/4/2026",
            service: "Căng da, xóa nhăn Thermage Max Effect",
        },
        {
            key: 2,
            code: "#96855732",
            branch: "—",
            customer: "Huan Phan Cao 123",
            createdBy: "Nhân sự",
            time: "15:07:06 17/4/2026",
            service: "—",
        },
    ];

    const productData = [
        {
            key: 1,
            code: "#999111",
            branch: "Chi nhánh 100",
            customer: "Nguyễn Văn A",
            createdBy: "Admin User",
            time: "10:00 18/4/2026",
            service: "Combo dầu gội + serum phục hồi tóc",
        },
        {
            key: 2,
            code: "#999222",
            branch: "Chi nhánh 200",
            customer: "Trần Thị B",
            createdBy: "Nhân sự",
            time: "11:30 18/4/2026",
            service: "Bộ dưỡng da chuyên sâu",
        },
    ];

    const columns = [
        {
            title: "Mã lịch hẹn",
            dataIndex: "code",
            render: (t: string) => <span className="text-blue-500">{t}</span>,
        },
        { title: "Chi nhánh", dataIndex: "branch" },
        {
            title: "Khách hàng",
            dataIndex: "customer",
            render: (t: string) => <span className="text-blue-500">{t}</span>,
        },
        {
            title: "Được tạo bởi",
            render: (_: any, r: any) => (
                <div>
                    <div>{r.createdBy}</div>
                    <div className="text-xs text-gray-400">{r.time}</div>
                </div>
            ),
        },
        { title: "Dịch vụ", dataIndex: "service" },
    ];

    const toggleLine = (key: string) => {
        setHiddenLines((prev) =>
            prev.includes(key)
                ? prev.filter((k) => k !== key)
                : [...prev, key]
        );
    };

    return (
        <div className="space-y-4">
            <Row gutter={[16, 16]}>

                {/* LEFT */}
                <Col xs={24} xl={8}>
                    <Card className="dark:bg-[#141414] dark:border-[#303030] h-full text-000000e0">
                        <div className="text-center text-gray-500">Tổng chi tiêu</div>
                        <div className="text-center text-2xl font-semibold mb-4">0</div>

                        <div className="grid grid-cols-2 text-center border-t">
                            <div className="py-4 border-r">
                                <div className="text-xl">0</div>
                                <div className="text-sm text-gray-500">
                                    SL hóa đơn dịch vụ
                                </div>
                            </div>
                            <div className="py-4">
                                <div className="text-xl">10</div>
                                <div className="text-sm text-gray-500">
                                    SL hóa đơn sản phẩm
                                </div>
                            </div>
                        </div>

                        <div className="grid grid-cols-2 text-center border-t">
                            <div className="py-4 border-r">
                                <div className="text-xl">0</div>
                                <div className="text-sm text-gray-500">
                                    Tổng tiền dịch vụ
                                </div>
                            </div>
                            <div className="py-4">
                                <div className="text-xl">0</div>
                                <div className="text-sm text-gray-500">
                                    Tổng tiền sản phẩm
                                </div>
                            </div>
                        </div>
                    </Card>
                </Col>

                {/* RIGHT */}
                <Col xs={24} xl={16}>
                    <Card className="dark:bg-[#141414] dark:border-[#303030] h-full">

                        {/* HEADER */}
                        <div className="flex justify-between mb-3">
                            <div className="font-medium text-000000e0">
                                Thống kê số lượng hóa đơn giao dịch trong năm
                            </div>

                            <Select
                                value={year}
                                onChange={setYear}
                                options={[
                                    { label: "2024", value: "2024" },
                                    { label: "2025", value: "2025" },
                                    { label: "2026", value: "2026" },
                                ]}
                                size="small"
                                className="w-[100px]"
                            />
                        </div>

                        {/* CHART */}
                        <ResponsiveContainer width="100%" height={250}>
                            <LineChart data={chartData} margin={{ top: 5, right: 10, left: -35, bottom: 5 }}>
                                <XAxis dataKey="name" interval={0} />
                                <YAxis />
                                <Tooltip />

                                {!hiddenLines.includes("service") && (
                                    <Line dataKey="service" stroke="#3b82f6" />
                                )}
                                {!hiddenLines.includes("product") && (
                                    <Line dataKey="product" stroke="#9ca3af" />
                                )}
                            </LineChart>
                        </ResponsiveContainer>

                        {/* LEGEND */}
                        <div className="flex gap-4 justify-center mt-2 text-000000e0">
                            <span
                                onClick={() => toggleLine("service")}
                                className="cursor-pointer flex items-center gap-1"
                            >
                                <span className="w-3 h-3 bg-blue-500 inline-block" />
                                Hóa đơn dịch vụ
                            </span>

                            <span
                                onClick={() => toggleLine("product")}
                                className="cursor-pointer flex items-center gap-1"
                            >
                                <span className="w-3 h-3 bg-gray-400 inline-block" />
                                Hóa đơn sản phẩm
                            </span>
                        </div>
                    </Card>
                </Col>
            </Row>
            {/* TABS */}
            <Tabs
                activeKey={tab}
                onChange={setTab}
                items={[
                    { key: "service", label: "Dịch vụ" },
                    { key: "product", label: "Sản phẩm" },
                ]}
            />

            {/* TABLE */}
            <Table
                columns={columns}
                dataSource={tab === "service" ? serviceData : productData}
                pagination={false}
                className="custom-ant-table"
                scroll={{ x: "max-content" }}
            />
        </div>
    );
}